import React, { useState } from 'react'
import ResultBox from '../../components/ResultBox'
import DisclaimerBox from '../../components/DisclaimerBox'
import { MdOutlineFeedback } from 'react-icons/md'
import { renderTestResultCategory, renderTestResultMessage } from '../../utils'
import Carousel from '../../components/Carousel'
import ImagePreview from '../../components/ImagePreview'
import { MdDateRange } from 'react-icons/md'
import { MdLogin } from 'react-icons/md'
import { FaHourglass } from 'react-icons/fa'
import { FaArrowRight } from 'react-icons/fa'
import { FaUser } from 'react-icons/fa'
import { FaUserDoctor } from 'react-icons/fa6'
import { FaImage } from 'react-icons/fa'
import { FaArrowLeft } from 'react-icons/fa'

export default function TestResult({ testResult, onBack }) {
  const [imagePreviewImagePath, setImagePreviewImagePath] = useState('')
  const [imagePreviewState, setImagePreviewState] = useState(false)

  return (
    <>
      <main className="test-result-page">
        <div className="test-result-container">
          <div className="test-result-header">
            <button className="back-button" onClick={onBack}>
              <FaArrowLeft /> Back to Form
            </button>
            <h1>Test Result</h1>
          </div>
          {renderTestResultCategory(testResult.labTestResult)}
          {renderTestResultMessage(testResult.labTestResult, testResult.labTestResultMessage ?? 'N/A')}
          <DisclaimerBox label="Disclaimer" value="Vasectomies are highly effective, but failure can occur. This test result reflects only the sample analyzed and does not guarantee permanent sterility. Clinical decisions, including the discontinuation of contraceptives, should be made in consultation with a medical provider." />
          <ResultBox icon={<MdDateRange />} label="Test Date" value={testResult.labTestResultDate ?? 'N/A'} />
          <ResultBox icon={<MdLogin />} label="Kit ID" value={testResult.kitId ?? 'N/A'} />
          <ResultBox icon={<FaUser />} label="Patient" value={testResult.patientName ?? 'N/A'} />
          <ResultBox icon={<FaUserDoctor />} label="Provider" value={testResult.providerName ?? 'N/A'} />
          <ResultBox icon={<MdDateRange />} label="Vasectomy Date" value={testResult.vasectomyDate ?? 'N/A'} />
          {testResult.patientPictures && (
            <div className="result-box">
              <p className="result-label">
                <FaImage /> Test Result Pictures
              </p>

              <Carousel
                items={
                  testResult.patientPicturesArtifacts.length > 0
                    ? testResult.patientPicturesArtifacts
                        .filter((pic) => !pic.isPatientIdCard)
                        .map((pic) => (
                          <img
                            style={{ cursor: 'pointer' }}
                            draggable={false}
                            onClick={() => {
                              setImagePreviewImagePath(pic.url)
                              setImagePreviewState(true)
                            }}
                            src={pic.url}
                            alt={pic.key}
                            key={pic.key}
                          />
                        ))
                    : [<p>No pictures available</p>]
                }
              />
            </div>
          )}
        </div>

        <div className="up-sell-container">
          <div>
            <h2>{<FaHourglass />} When should I test next?</h2>
            <p>
              A vasectomy is highly effective, but in rare cases the vas deferens can reconnect over time, known as recanalization. 
            </p>
            <p>
              Testing again after one year (<i>some men test annually</i>) helps ensure your result remains clear and gives you lasting confidence.
            </p>
          </div>
          <a href="https://www.malefromhome.com/">
            Order Another Testing Kit <FaArrowRight />
          </a>
        </div>

        <div className="footer">
          <p>Thanks for using MaleFromHome.com. If you have any feedback on our service, we'd love to hear from you!</p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfQ-XsJlAcd0m2CuIUj03zYtHazHzyIyhGkacLGMcHnMEjEsw/viewform?usp=sf_link">
            <MdOutlineFeedback /> Leave Feedback
          </a>
        </div>
      </main>
      <ImagePreview imagePath={imagePreviewImagePath} open={imagePreviewState} setOpen={(bool) => setImagePreviewState(bool)} />
    </>
  )
}
